<div class="row">
  <div class="col col-12 p-0" #chartRevQuantityContainer>
    <ngx-charts-bar-horizontal [view]="view" [scheme]="bluePalette" [results]="brokerModuleQty" [gradient]="gradient"
      [xAxis]="showXAxis" [yAxis]="showYAxis" [legend]="showLegend" [showXAxisLabel]="showXAxisLabel"
      [showYAxisLabel]="showYAxisLabel" [xAxisLabel]="xAxisLabel" [yAxisLabel]="yAxisLabel">
    </ngx-charts-bar-horizontal>
  </div>
</div>
<div class="row pt-3">
  <div class="col col-12">
    <p class="text-3 mb-3 text-center text-primary">Files reviewed per broker</p>
  </div>
</div>